import React from "react";
import Hero from "../Hero";

export default function HeroBlock({ id, type, ...content }) {
  return <Hero content={content} />;
}
